import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg',
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        // TODO: set colors dynamically
        primary: '#1A3153',
        'header-background': '#FFFFFF',
        'page-background': '#f8f8f8',
        'header-text': '#383838',
        'body-background': '#FFFFFF',
        'body-text': '#353535',
        'accent-text': '#011E4A',
        'inactive-text': '#B8B8B8',
        //primary button
        'primary-button': '#3B4766',
        'primary-button-text': '#FFFFFF',
        //secondary button
        'secondary-button': '#FFFFFF',
        'secondary-button-text': '#123262',
        'inactive-button': '#DEDEDE',
        'inactive-button-text': '#FFFFFF',
        'primary-label': '#EEF1F4',
        'primary-label-text': '#303030',
        'primary-label-border': '#EEF1F4',
        'secondary-label': '#FFFFFF',
        'secondary-label-text': '#FFFFFF',
        'secondary-label-border': '#D0D0D0',
        'field-background': '#FFFFFF',
        'field-text': '#1A3153',
        'field-border': '#E3E9F2',
        'info': '#70A9FF',
        'accent-lighten4': '#F8F8F8',
        'accent-lighten3': '#A8A4A4',
      },
    },
  },
})
